import React from 'react'
import ReactGA from 'react-ga';

export default ({path, title, ...props}) => {

  console.log("Location ",window.location.pathname )
  ReactGA.pageview(path, title);

  return ""
}



// WEBPACK FOOTER //
// ./src/components/PageAnalytics.js